<template>
<div id="pedido">
    <div :id="'titlePedido' + index">
        <label>Pedido {{linha.id}} - {{linha.data_hora_conclusao | trataData }}</label><br>
        <!-- Pedido {{linha.id}}<br> -->
        {{linha.cliente.nome.toUpperCase()}} <br>
        {{linha.cliente.contato}}<br>
        <!-- telefone -->
    </div>
    <div :id="'bodyPedido' + index">
        <div class="row">
            <div class="col-sm-12 table-responsive" :id="'itensNovo'+ index">
                    <div class="row">
                        <label>ITENS</label>
                    </div>
                    <div class="even" v-for="item in linha.itensPedido">
                        {{item.qtde}} - R$ {{item.total.toFixed(2)}} - {{item.nome}} {{item.descricao && item.descricao.length < 50 ? `(${item.descricao})` : ''}}<br>
                        <div v-if="item.adicionais" v-for="adc in item.adicionais" class="adicionais">
                            + {{adc.qtde}} - {{adc.produtos.nome}}
                        </div>
                        <br>-------------------------------------------
                    </div>
                                        
            </div>
            
        </div>
        <div class="row">
            <div class="col-sm-4 table-responsive" style="margin-top: 2%" :id="'pagamentoNovo' + index">
                    <div v-for="coluna in colunas_pagamento">
                        {{coluna }}
                    </div>
                    <div v-for="p in linha.formaPagamento">
                        <label>{{p.pagamento.nome}}</label>
                        <label v-if="p.pagamento.nome !== 'dinheiro'">{{p.observacao}}</label>
                        <label v-else>Troco: R${{(parseInt(p.observacao) - linha.preco_total).toFixed(2)}} (Troco para R${{p.observacao}})</label>
                    </div>
                -------------------------------------------
                <div v-show="linha.desconto && linha.desconto > 0">
                 Desconto: {{linha.desconto}}%
                -------------------------------------------
                </div>
                <br><label style="font-size: 15px">Total do Pedido: {{linha.preco_total.toFixed(2)}}</label>
            </div>
            <div class="col-sm-8 endereco" style="margin-top: 3%" >
                <div class="endereco-title">
                <label style="font-size: 15px">Endereço de Entrega</label>
                </div>
                <div class="endereco-body" :id="'enderecoNovo' + index">
                    <div v-if="linha.enderecosPedidos && linha.enderecosPedidos.length > 0">
                        <label class="lblEnd">Rua: {{linha.enderecosPedidos[0].enderecos.rua}}</label><br>
                        <label class="lblEnd">Numero: {{linha.enderecosPedidos[0].enderecos.numero}}</label><br>
                        <label class="lblEnd">Bairro: {{linha.enderecosPedidos[0].enderecos.bairro}}</label><br>
                        <label class="lblEnd">Complemento: {{linha.enderecosPedidos[0].enderecos.complemento}}</label>
                    </div>
                    <div v-else-if="linha.cliente.enderecoCliente && linha.cliente.enderecoCliente.length > 0">
                        <label class="lblEnd">Rua: {{linha.cliente.enderecoCliente[0].rua}}</label><br>
                        <label class="lblEnd">Numero: {{linha.cliente.enderecoCliente[0].numero}}</label><br>
                        <label class="lblEnd">Bairro: {{linha.cliente.enderecoCliente[0].bairro}}</label><br>
                        <label class="lblEnd">Complemento: {{linha.cliente.enderecoCliente[0].complemento}}</label>
                    </div>
                    <div v-else>
                        <label class="lblEnd">Irá Retirar</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  props: ['index', 'linha'],
  data () {
      return {
            colunas_impressao: ['Qtd', 'Item', 'Preco'],
            colunas_pagamento: ['Formas Pagamento',''],
      }
  },
  created() {
      console.log('pedidos -> ', this.linha)
  },
  filters: {
    trataData(value) {
        if(value) {
            var data = new Date(value)
            var dia = data.getDate()
            var mes = data.getMonth() + 1
            var ano = data.getFullYear()
            var hr = data.getHours()
            var min = data.getMinutes()
            return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min
        }
    },
  }
}
</script>
<style>
.adicionais {
  font-size: 12px;
  font-style: italic;
  margin: 0
}
</style>





// WEBPACK FOOTER //
// ModalNovoPedido.vue?93269866